import { NotificationStyle, NotificationType } from '~/shared';
import { BackendService } from '../BackendService';
import type { IRpcService } from '../RpcService';
import { AbstractNotificationsService } from './AbstractNotificationsService';
import {
	INotificationProgressOptions,
	INotificationsService,
	IShowNotificationOptions,
} from './notificationsServiceTypes';

export class NotificationsService
	extends AbstractNotificationsService
	implements INotificationsService
{
	constructor(
		rpc: IRpcService,
		private readonly backend: BackendService,
	) {
		super();

		rpc.register('notifications:show', (payload: IShowNotificationOptions) =>
			this.showNotification(payload),
		);

		rpc.register(
			'notifications:showProgress',
			(payload: INotificationProgressOptions) =>
				this.showProgress(payload.text, payload.duration, payload.icon),
		);

		rpc.register('notifications:hideProgress', () => this.hideProgress());

		rpc.register('notifications:poll', () => this.pollBackendNotifications());
	}

	private async pollBackendNotifications(): Promise<void> {
		const { notifications } = await this.backend.invoke<{
			notifications: { style: NotificationStyle; message: string }[];
		}>('notifications:poll');

		for (const notification of notifications) {
			this.showNotification({
				type: NotificationType.Default,
				text: notification.message,
				style: notification.style,
			});
		}
	}
}
